export function setCookie (cname, cvalue) {
  document.cookie = `${cname}=${cvalue}; secure; samesite=strict`
}
export function getCookie (cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (const value of ca) {
    let c = value
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
